import React, {useEffect, useState} from "react";
import ExitButton from "../../buttons/ExitButton";
import SendMessageButton from "../../buttons/SendMessageButton";
import TextareaMessageTo from "../../inputs/TextareaMessageTo";
import {sendActWithTeamRequest} from "./ActWithTeamAction";
import {useDispatch, useSelector} from "react-redux";
import {MESSAGE} from "../../inputs/inputTypes";
import styled from "styled-components";
import {BaseModal} from "../../modal/modalStyle";
import Checkbox from "../../inputs/Checkbox";
import {CLEAR_MESSAGE} from "../../message/actions/actionTypes";
import SendMessageLoader from "../../progress-bar/SendMessageLoader";

const ActWithTeamModal = ({setOpenActWithTeamModal}) => {

    const dispatch = useDispatch();
    const {id} = useSelector(state => state.project)
    const {isPending} = useSelector(state => state.message)

    const [selectedOption, setSelectedOption] = useState({
        message: ""
    })


    useEffect(() => {
        return () => {
            dispatch({type: CLEAR_MESSAGE})
        }
    }, [dispatch])

    const actionChoices = [
        {
            id: 0,
            name: "Apportez de nouvelles idées pour enrichir et faire avancer notre projet"
        },
        {
            id: 1,
            name: "Réagissez aux idées des autres"
        },
        {
            id: 2,
            name: "Mettez à jour vos actions et résultats clés pour faire avancer le projet"
        },
    ]


    const [idsSelected, setIdsSelected] = useState([])

    const handleChange = (e) => {
        const targetType = e.target.type
        if (targetType === "checkbox") {
            const isChecked = e.target.checked;
            const idSelected = parseInt(e.target.value)
            if (isChecked) {
                setIdsSelected(oldArray => [...oldArray, idSelected])
            } else {
                setIdsSelected(idsSelected.filter(id => id !== idSelected))
            }
        } else if (targetType === "textarea") {
            const {name, value} = e.target;
            setSelectedOption(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    }

    const closeUpdate = () => {
        setOpenActWithTeamModal(false)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        let data = {}
        if (idsSelected.length > 0) {
            data.ids = idsSelected
        }
        if (selectedOption.message.trim() !== "") {
            data.message = selectedOption.message
        }

        await dispatch(sendActWithTeamRequest(id, data))
        setTimeout(() => closeUpdate(), 1000)

    }

    return (
        <div className="shadow">
            <Container>
                <TitleSection>
                    <h1> J'agis avec mon équipe </h1>
                    <ExitButton
                        closeUpdate={closeUpdate}
                    />
                </TitleSection>
                <Form onSubmit={handleSubmit}>
                    <Wrapper>
                        {actionChoices.map(({name, id}, index) => {
                            return (
                                <li key={index}>
                                    <Checkbox
                                        title={name}
                                        id={id}
                                        value={id}
                                        name={name}
                                        handleChange={handleChange}
                                        checked={idsSelected.includes(id)}
                                    />
                                </li>)
                        })}
                    </Wrapper>
                    <TextareaMessageTo
                        selectedOption={selectedOption}
                        name={MESSAGE}
                        handleChange={handleChange}
                        placeholder={""}
                    />
                    {isPending &&
                    <SendMessageLoader/>
                    }
                    <SendMessageButton/>
                </Form>
            </Container>
        </div>
    )
}

const Container = styled(BaseModal)`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  height: fit-content;
  padding: 2em 2em;
  inset: 0;
  @media (min-width: 600px) {
    width: 600px;
    height: fit-content;
  }
`
const TitleSection = styled.div`
  display: flex;
  flex-direction: row;

  h1 {
    text-align: center;
    flex-grow: 1;
  }

  .exit-btn {
    align-self: flex-start;
    transform: translateY(-50%);
  }

  @media (min-width: 600px) {
    h1 {
      margin-bottom: 0;

    }
  }

`
const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: 2em;
  gap: 2em;

  fieldset {
    width: 100%;
    border: none;
    height: 10rem
  }

  label h3 {
    margin-bottom: 0.5em;
  }

  textarea {
    width: 100%;
    height: 10rem
  }

  button {
    align-self: center;
  }

  @media (min-width: 600px) {
    gap: 1rem;
    fieldset {
      border: none;
      height: unset;
    }

    textarea {
      height: unset;
    }

    #msg-to {
      height: 250px;
    }
  }
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  li {
    list-style-type: none;
  }

  li > input:checked {
    background-color: rgba(73, 9, 170, 1);
  }
`

export default ActWithTeamModal;